// Hosted DEV environment — used by `npm run build:dev`.
export const environment = {
  production: false,
  customerUrl: 'https://customer-dev.orderyaa.com',
  partnerUrl: 'https://partner-dev.orderyaa.com',
  riderUrl: 'https://rider-dev.orderyaa.com',
  erpAppUrl: 'https://erp-dev.orderyaa.com',
};
